import * as Yup from 'yup';

export const validationSchema = Yup.object({
  channel_id: Yup.string().required('O canal é obrigatório'),
  business_manager_id: Yup.string().required(
    'O número do Gerenciador de Negócios é obrigatório'
  ),
});
